Pegasus.SimpleSpinnerView = Ember.View.extend({
  templateName: 'controls/simple_spinner'
});